import React, {useCallback} from 'react'
import Grid from './Grid'
import {Heading} from '@miro-site/core'
import {useSplitIo} from '@miro-site/splitio'
import {useLocalization} from '@miro-site/localization'
import {IHighlighted, ITemplates} from '../api/interfaces'
import SecondaryNavigationItem from './SecondaryNavigationItem'
import styled, {useTheme} from 'styled-components'
import Highlighted from './Highlighted'
import HeroBannerHighlighted from './HeroBannerHighlighted'

const TemplatesNavGrid = styled(Grid)`
  ${props =>
    props.theme.normalizeStyles({
      marginBottom: 43,
    })}
`

const TemplatesHighilighted = (props: ITemplates): React.ReactElement => {
  const {popularTemplates, navigationGroup} = props

  const theme = useTheme()
  const {currentLocale} = useLocalization()
  const [{error, isLoading}, splitIoClient] = useSplitIo()

  const treatment = splitIoClient?.getTreatment('RTB-110712-miroverse-hero-banner')

  const getContent = useCallback(
    (treatment: string, error: string, currentLocale: string, popularTemplates: IHighlighted) => {
      if (error || currentLocale !== 'en') {
        return <Highlighted {...popularTemplates} />
      }
      return <HeroBannerHighlighted treatment={treatment} {...popularTemplates} />
    },
    [treatment],
  )

  return (
    <>
      <Heading $my={5} $variant="h4">
        {navigationGroup.title}
      </Heading>
      <TemplatesNavGrid gutter={theme.header.grid.gutter} columns={[null, null, 2, 4, 6]}>
        {navigationGroup.items.map(i => (
          <Grid.Column key={i.title} columns={[null, null, 1, 2, 3]}>
            <SecondaryNavigationItem
              key={i.title}
              path={i.path}
              title={i.title}
              description={i.description}
            />
          </Grid.Column>
        ))}
      </TemplatesNavGrid>
      {!isLoading && getContent(treatment, error, currentLocale, popularTemplates)}
    </>
  )
}

export default TemplatesHighilighted
